import { TransferEditContainerComponent } from './transfer/containers/edit/edit.transfer.container';
import { MODAL_CONTAINER_KEYS } from './container-keys';

export const CONTAINER_MAPPING = {
  [MODAL_CONTAINER_KEYS.TransferDetail]: TransferEditContainerComponent,
};
